import { useState, useEffect } from "react";

// API
import { getESG } from "../api/esgImpact";

// Bootstrap components
import Container from "react-bootstrap/Container";

// Custom styles
import "../scss/pages/esgImpact.styles.scss";

// Assets
import logoESR from "../assets/images/esr-logo-blanco.png";
import iconVerde from "../assets/images/beneficio-verde.png";
import iconRosa from "../assets/images/beneficio-rosa.png";
import iconAzul from "../assets/images/beneficio-azul.png";
import imgClientesMd from "../assets/images/nuestros-clientes-md.jpg";

function ESGImpact() {
  const [loading, setLoading] = useState(false);
  const [esgData, setESGData] = useState({});
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const { response, result } = await getESG();
        if (response.status === 304) {
          setESGData(result.docs[0]);
        } else if (!response.ok) {
          console.error("Error fetching home :", response.ok);
        } else {
          setESGData(result.docs[0]);
        }
      } catch (error) {
        console.error("Error fetching  data", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  if (Object.keys(esgData).length === 0) {
    return (
      <Container style={{ marginTop: "90px" }}>
        <h6 className="text-center py-3">Cargando información...</h6>
      </Container>
    );
  }
  return (
    <div className="esg_wrapper">

<section className="esg_hero">
  <div className="container">
    <div className="row">
            
      <div className="col-12 col-lg-8">
        
        <h1 className="commitment-title">
          Compromiso<span className="text-green"> ASG:</span> 
        </h1>
        
        <h3 className="commitment-subtitle">
          {esgData?.title}
        </h3>

        <p>
          En AFIX creemos que <strong>la sostenibilidad no es solo una responsabilidad, sino <br className="d-none d-lg-block" />
          una oportunidad</strong> para construir un futuro más próspero. Es un pilar <br className="d-none d-lg-block" />
          estratégico que impulsa el crecimiento responsable, fortalece nuestra <br className="d-none d-lg-block" />
          competitividad y contribuye al bienestar de la comunidad a la que servimos.
        </p>

        <p>
          Como institución financiera, asumimos con convicción nuestro rol como <br className="d-none d-lg-block" />
          agentes de cambio, <strong>promoviendo prácticas que generan valor económico, <br className="d-none d-lg-block" />
          social y ambiental,</strong> tanto en nuestra operación como a través de las PyMEs <br className="d-none d-lg-block" />
          que financiamos.
        </p>
        
      </div>
      
    </div>
  </div>
</section>

<section className="esg_cemefi">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-12 col-md-4 col-lg-3 logo-column text-center text-md-start">
          <img src={logoESR} alt="Empresa Socialmente Responsable" className="esr-logo" />
        </div>
        <div className="col-12 col-md-8 col-lg-8 text-column">
          <p>
            Desde <strong>2024 hemos sido reconocidos como Empresa Socialmente 
            Responsable por CEMEFI,</strong> por segundo año consecutivo logramos el 
            distintivo con resultados sobresalientes en el proceso general y en la 
            industria. La metodología del Distintivo ESR® contempla 4 criterios y 
            9 ámbitos, los cuales están alineados a los Objetivos de 
            Desarrollo Sostenible de la ONU.
          </p>
        </div>
      </div>
    </div>
  </section>

  <section className="esg_clientes">
    <div className="container">
      <div className="row align-items-center">
        
        <div className="col-12 col-lg-6 text-column">
          <h2 className="impact-title">
            {esgData?.clientImpactTitle}
          </h2>
          <p>
            {esgData?.clientImpactDescription}
          </p>
         </div>
      </div>

      <img src={imgClientesMd} alt="" className="md-foto d-lg-none" />
    </div>
  </section>

  <section className="esg_beneficios">
  <div className="container">
      <div className="row mb-5">
      <div className="col-12">
        <p className="benefits-intro">
          <strong>{esgData?.benefitsDescription}</strong>
        </p>
      </div>
    </div>

    <div className="benefits-list">
      <div className="benefit-card bg-light-gray">
        <div className="row g-0 align-items-stretch">
          <div className="col-12 col-md-4 col-lg-3 benefit-badge bg-green">
            <img src={iconVerde} alt="Icono Verde" className="benefit-icon" />
            <span className="benefit-name">Beneficio verde</span>
          </div>
          <div className="col-12 col-md-8 col-lg-9 benefit-content d-flex align-items-center">
            <p>
              Tiene como fin apoyar y consolidar todos aquellos <strong>proyectos ambientales,</strong> tales como 
              energías renovables, prevención y manejo de contaminación, eficiencia energética, 
              gestión del agua y aguas residuales, gestión de recursos naturales, conservación de la 
              biodiversidad y adaptación al cambio climático.
            </p>
          </div>
        </div>
      </div>

      {/* Beneficio Rosa */}
      <div className="benefit-card bg-white">
        <div className="row g-0 align-items-stretch">
          <div className="col-12 col-md-4 col-lg-3 benefit-badge bg-pink">
            <img src={iconRosa} alt="Icono Rosa" className="benefit-icon" />
            <span className="benefit-name">Beneficio rosa</span>
          </div>
          <div className="col-12 col-md-8 col-lg-9 benefit-content d-flex align-items-center">
            <p>
              Tiene como fin apoyar y consolidar todas aquellas <strong>PYMES que brinden empleo a mujeres,</strong> con el objetivo de erradicar las brechas salariales.
            </p>
          </div>
        </div>
      </div>

      {/* Beneficio Azul */}
      <div className="benefit-card bg-light-gray">
        <div className="row g-0 align-items-stretch">
          <div className="col-12 col-md-4 col-lg-3 benefit-badge bg-blue">
            <img src={iconAzul} alt="Icono Azul" className="benefit-icon" />
            <span className="benefit-name">Beneficio azul</span>
          </div>
          <div className="col-12 col-md-8 col-lg-9 benefit-content d-flex align-items-center">
            <p>
              Tiene como fin apoyar y consolidar todos aquellos <strong>proyectos que retribuyen a la sociedad</strong> y que a su vez incorporen en su plantilla como miembros activos de la organización a <strong>personas con diversidad funcional,</strong> es por eso que este beneficio es destinado a PYMES y personas físicas con actividad empresarial que tengan en su plantilla desde 1 persona con diversidad funcional.
            </p>
          </div>
        </div>
      </div>

    </div>

    {/* --- BOTÓN --- */}
    <div className="row mt-5">
      <div className="col-12 text-center">
        <a href="#reporte" className="btn-sustainability">
          Reporte de Sostenibilidad
        </a>
      </div>
    </div>

  </div>
</section>

      
{/*       <section className="esg_hero">
        <div className="esg_description">
          <h5
            style={
              esgData?.esgDescription[0]?.children[0]?.bold === true
                ? { fontWeight: "bolder", fontFamily: "Rubik, sans-serif" }
                : { fontWeight: "lighter" }
            }
          >
            {esgData?.esgDescription[0]?.children[0]?.text}
          </h5>
          <h6
            style={
              esgData?.esgDescription[1]?.children[0]?.bold === true
                ? { fontWeight: "bolder", fontFamily: "Rubik, sans-serif" }
                : { fontWeight: "lighter" }
            }
          >
            {" "}
            {esgData?.esgDescription[1]?.children[0]?.text}
          </h6>
          <p>{esgData?.esgDescription[2]?.children[0]?.text}</p>
          <p>{esgData?.esgDescription[3]?.children[0]?.text}</p>
        </div>
        <div className="esg_hero__media">
          <div className="esg_hero__media__heading">
            <h3>{esgData?.title}</h3>
            <img src={leafOpacity} alt="" />
          </div>
          <div className="esg_hero__media__image">
            <img
              src={`${process.env.REACT_APP_HOME_API_URL}${esgData?.EsgHero.url}`}
              alt=""
            />
          </div>
          <div className="esg_hero__media__stats">
            <div>
              <div>
                <h4>+{esgData?.treesStat}</h4>
                <span>{esgData?.treesText}</span>
              </div>
              <p>{esgData?.treesDescription}</p>
            </div>
            <div>
              <p>{esgData?.description}</p>
            </div>
          </div>
        </div>
      </section>
      <section className="esg_onu">
        <div>
          <h6>{esgData?.ONUDescription[0]?.children[0]?.text}</h6>
          <h6 className="mt-3">
            {esgData?.ONUDescription[1].children[0]?.text}
          </h6>
        </div>
        <div>
          <img
            src={`${process.env.REACT_APP_HOME_API_URL}${esgData?.ONUMedia.url}`}
            alt=""
          />
        </div>
      </section>
      <section className="esg_impact">
        <div className="esg_impact__heading">
          <div className="d-flex">
            <img
              src={`${process.env.REACT_APP_HOME_API_URL}${esgData?.clientImpactMedia.url}`}
              alt=""
            />
            <div className="d-flex flex-column">
              <h4>{esgData?.clientImpactTitle}</h4>
              <p className="my-3">{esgData?.clientImpactDescription}</p>
            </div>
          </div>
          <div className="esg_impact__heading__card">
            <p>{esgData?.benefitsDescription}</p>
          </div>
        </div>
        <div className="esg_impact__benefits">
          {esgData?.benefits.map((item2, key) => (
            <div className="esg_impact__benefit" key={key}>
              <div className="esg_impact__benefit_heading">
                <img
                  src={`${process.env.REACT_APP_HOME_API_URL}${item2.benefitMedia.url}`}
                  alt=""
                />
                <p>{item2.benefitTitle}</p>
              </div>
              <div className="esg_impact__benefit_body">
                <p key={key}>{item2.benefitDescription[0].children[0]?.text}</p>
              </div>
            </div>
          ))}
        </div>
      </section> 

*/}

    </div>
  );
}

export default ESGImpact;
